export enum CompanyType {
  SettlementCompany = 'Settlement Company',
  TitleCompany = 'Title Company',
}
